module.exports = "<button class=\"btn btn-primary btn-lg \" (click)= \"event()\" id=\"playButton\">Play Interval</button>"


//////////////////
// WEBPACK FOOTER
// /Users/ericzayas/Documents/relativePitch/src/app/components/easy/easy.component.html
// module id = ../../../../../src/app/components/easy/easy.component.html
// module chunks = main